import { Link } from "gatsby"
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import './header.css';

export const HomeHeader = () => {
  const data = useStaticQuery(graphql`
    query {
      logo:file(base: {eq: "logo.svg"}) {
        base
        publicURL
      }
    }
  `)

  return (
    <header
      className="Layout__Header HomeHeader"
    >
      <img className="HomeHeader__Logo" src={data.logo.publicURL} alt="FUEL4Design"/>
      <span className="AppTitle">(online) <strong>Reflexicon</strong></span>
    </header>
  )

}

export const ModeHeader = ({ title, color }) => {

  return (
    <header
      className="Layout__Header ModeHeader"
    >
      <span className="ModeHeader_Title AppTitle">(online) <strong>Reflexicon:</strong> <span style={{ color: color }}>{title}</span></span>
      <Link to="/reflexicon" className="button" >SWITCH GAME MODE</Link>
    </header>
  )

}
